import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Scroll from '@components/Scroll'
import ACL from '@components/ACL'
import Button from '@components/Button'
import ReloadIcon from '@components/Icon/Reload'

const SearchPanelContainer = ({
  children,
  thin,
  extrathin,
  wide,
  searchTitle,
  onClearSearch,
  isMyProjectsPanel,
  buttonProps,
  clearSearchText,
  expertHistory
}) => {
  const classes = classNames({
    'search-panel': true,
    'search-panel-thin': thin,
    'search-panel-extrathin': extrathin,
    'search-panel-expert-history': expertHistory
  })
  const containerClasses = classNames({
    'search-panel-container': true,
    'search-panel-container--my-projects-panel': isMyProjectsPanel,
    'search-panel-container--wide': wide,
    'search-panel-container--expert-history': expertHistory
  })
  const containerWrapperClasses = classNames({
    'search-panel-container__wrapper': !isMyProjectsPanel,
    'search-panel-container__wrapper--expert-history': expertHistory
  })

  const buttonText = buttonProps && buttonProps.buttonText
  return (
    <div className={classes}>
      <div className={containerClasses}>
        <Scroll>
          <div className={containerWrapperClasses}>
            <RenderButton {...buttonProps} />
            <div
              className={`search-panel-container__title 
              ${buttonText ? 'm-t-xl' : ''} 
              ${expertHistory
                  ? 'search-panel-container__title--expert-history'
                  : ''
                }`}
            >
              <h2>{searchTitle}</h2>
              {!!onClearSearch && (
                <div
                  className={`search-panel-container__title--action 
                  ${expertHistory
                      ? 'search-panel-container__title--action--expert-history'
                      : ''
                    }`}
                  onClick={onClearSearch}
                >
                  <ReloadIcon />
                  <span className='row--link m-l-sm'>
                    {clearSearchText || 'Clear search'}
                  </span>
                </div>
              )}
            </div>
            {children}
          </div>
        </Scroll>
      </div>
    </div>
  )
}

SearchPanelContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  thin: PropTypes.bool,
  extrathin: PropTypes.bool,
  wide: PropTypes.bool,
  searchTitle: PropTypes.string,
  onClearSearch: PropTypes.func,
  isMyProjectsPanel: PropTypes.bool,
  buttonProps: PropTypes.object,
  clearSearchText: PropTypes.string,
  expertHistory: PropTypes.bool
}

export default SearchPanelContainer

const RenderButton = ({ dataCy, buttonText, onClick, roles, disabled }) => {
  if (!buttonText) return null
  return roles ? (
    <ACL roles={roles}>
      <Button primary block disabled={disabled} data-cy={dataCy} onClick={onClick}>
        {buttonText}
      </Button>
    </ACL>
  ) : (
    <Button primary block disabled={disabled} data-cy={dataCy} onClick={onClick}>
      {buttonText}
    </Button>
  )
}

RenderButton.propTypes = {
  buttonText: PropTypes.string,
  dataCy: PropTypes.string,
  onClick: PropTypes.func,
  roles: PropTypes.array
}
